export default __webpack_public_path__ + "b225303c3eb152317fcdac5278863d99.svg";